import { ITag } from '@models/Tag.model';
import { IAddTagsToEquipmentVariables } from '@services/queries/tags/addTagsToInventoryItem/addTagsToInventoryItem';
import { QueryClient, UseMutationResult } from 'react-query';

interface OnAssignConfirmParams {
  mutation: UseMutationResult<
    ITag[],
    unknown,
    IAddTagsToEquipmentVariables,
    unknown
  >;
  params: {
    equipmentId: string;
  };
  queryClient: QueryClient;
}

export function onAssignConfirm(
  args: OnAssignConfirmParams,
): (
  newTags: Pick<ITag, 'id'>[],
  done: VoidFunction,
  err: VoidFunction,
) => void {
  const { mutation, params, queryClient } = args;
  return (newTags, done, err) => {
    mutation.mutate(
      {
        data: {
          equipmentId: params.equipmentId,
          tagsIds: newTags.map(t => t.id),
        },
      },
      {
        onSuccess() {
          queryClient.invalidateQueries(['equipments', params.equipmentId]);
          queryClient.resetQueries(['tags']);
          done();
        },
        onError() {
          err();
        },
      },
    );
  };
}
